module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-popup"
  }, [_vm._l((_vm.usersFilteredWithTags), function(user) {
    return (!_vm.isUserFiltered(user)) ? _c('div', {
      key: user.id,
      staticClass: "user"
    }, [_c('h4', [_vm._v("Opgaveoversigt " + _vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), _c('SubjectsDistributionUser', {
      attrs: {
        "activeUserId": user.id,
        "showCloseCross": false
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.isPrintSettingsModal) ? _c('DModal', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__content",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "modal__content__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('h2', [_vm._v("Print " + _vm._s(_vm.usersFilteredWithTags.length - _vm.filteredUsers.length) + " undervisere")]), _vm._v(" "), _c('label', {
    staticClass: "print-form__label"
  }, [_vm._v("Fravælg evt. undervisere")]), _vm._v(" "), _c('ul', {
    staticClass: "user-list"
  }, _vm._l((_vm.usersFilteredWithTags), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "user-list__item",
      class: {
        'user-list__item--disabled': _vm.isUserFiltered(user)
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilteredUser(user)
        }
      }
    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal__content__buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Luk")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary",
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print")])])])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-366dccd5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionPrint.vue
// module id = 1856
// module chunks = 1